"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledHighlighter = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var StyledHighlighter = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "StyledHighlighter",
  componentId: "c11n-8-107-0__sc-uzdygj-0"
})([""]);
exports.StyledHighlighter = StyledHighlighter;